import { AgGridReact } from "ag-grid-react";
import {
  questionColumnsMinimized,
  defaultColDef,
  getRowId,
} from "../../../utils/gridHelper";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useStore } from "../../../hooks/store";
import { getQuestion } from "../../../utils/API/questionMethods";

import IconButton from "@mui/material/IconButton";
import { postBiletQuestion } from "../../../utils/API/biletMethods";

export default function QuestionSmallGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [questionData, setQuestionData] = useState(undefined);

  const fetchQuestionData = () => {
    getQuestion().then(({ data }) => {
      setGridData(data);
    });
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchQuestionData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data &&
      postBiletQuestion(store.form.dataToUpdate.id, e.data.id).then(
        ({ data, status }) => {
          if (status === 200) {
            store.setAlert(data, "success");
            store.form.dataToUpdate.questions.push(e.data);
            store.closeChildModal();
            return;
          }
          store.setAlert(data, "error");
          return;
        }
      );
  };

  return (
    <div style={{ width: "300px", height: "300px", paddingTop: "20px" }}>
      <OutlinedInput
        sx={{ marginBottom: "10px" }}
        id={"quickFilter"}
        name={"quickFilter"}
        size="small"
        fullWidth
        onChange={(e) => setQuickFilterText(e.target.value)}
        value={quickFilterText}
        placeholder="Поиск вопроса"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              sx={{ p: "2px" }}
              onClick={() => setQuickFilterText("")}>
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        }
      />

      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...questionColumnsMinimized]}
      />
    </div>
  );
}
